import React from 'react'
import Select from 'react-select-v2';
import MessageUtils from '../../util/MessageUtils'
import './Select.css'

// menuIsOpen is used for initial state of the component
// https://react-select.com/home
const SelectUI = ({messageList, optionList, onChange, menuIsOpen, selectedKey, placeholder, placeholderKey,
    // multi
    selectedKeys, isMulti
  }) =>
  <Select
    className={`w_select ${isMulti ? 'multi' : 'single'}`}
    classNamePrefix='select'
    options={optionList}
    onChange={onChange}
    value={optionList && (isMulti ?
      optionList.filter(option => selectedKeys && selectedKeys.includes(option.value)) :
      optionList.filter(option => selectedKey === option.value)
    )}
    placeholder={placeholder || placeholderKey && MessageUtils.getMessageValue(messageList, placeholderKey)}
    closeMenuOnSelect={!isMulti}
    menuIsOpen={menuIsOpen}
    isMulti={isMulti}
  />

export default SelectUI
